import React, { useState, useRef, useEffect } from "react";
import "./styles.css";

const Selector = ({
  options,
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);

  // Синхронизируем searchTerm с выбранным значением, когда оно меняется
  useEffect(() => {
    if (value) {
      const selectedOption = options.find((opt) => opt.id === value);
      if (selectedOption) {
        setSearchTerm(selectedOption.name);
      } else {
        setSearchTerm("");
      }
    } else {
      setSearchTerm("");
    }
  }, [value, options]);

  // Когда список закрывается — восстанавливаем отображение выбранного значения
  useEffect(() => {
    if (!isOpen && value) {
      const selectedOption = options.find((opt) => opt.id === value);
      if (selectedOption) {
        setSearchTerm(selectedOption.name);
      }
    }
  }, [isOpen, value, options]);

  // Закрытие при клике вне
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (id) => {
    onChange(id);
    setIsOpen(false); // Закрываем после выбора
  };

  const handleInputClick = () => {
    // При клике — открываем список и сбрасываем поиск, чтобы показать все опции
    if (disabled) return;
    setSearchTerm("");
    setIsOpen(true);
  };

  const filteredOptions = options.filter(
    (option) =>
      option.name &&
      option.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="selector-container" ref={containerRef}>
      <input
        type="text"
        className="selector-input"
        placeholder={placeholder || "Выберите..."}
        value={searchTerm}
        onChange={(e) => {
          if (disabled) return;
          setSearchTerm(e.target.value);
          setIsOpen(true);
        }}
        onClick={handleInputClick} // ← Теперь очищаем searchTerm при клике, но восстанавливаем при закрытии
        autoComplete="off"
        disabled={disabled}
      />
      {isOpen && (
        <ul className="options-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <li
                key={option.id}
                onClick={() => handleSelect(option.id)}
                className={option.id === value ? "selected" : ""}
              >
                {option.name}
              </li>
            ))
          ) : (
            <li className="no-results">Ничего не найдено</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Selector;
